<ng-container *ngIf="is_ready">
  <mat-toolbar fxLayout="row" class="wrapper-header" color="primary" [ngStyle]="headerStyle" *ngIf="header">
    <div fxFlex>
      <span class="title">{{ header }}</span><span class="item-count">({{ availableAgentsOrdered.length }})</span>
    </div>
    <div fxFlex="40px">
      <button type="button" mat-icon-button (click)="displayContent = !displayContent">
        <mat-icon *ngIf="!displayContent">expand_more</mat-icon>
        <mat-icon *ngIf="displayContent">expand_less</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-card class="mat-card-flat pa-0 mt-0 mx-0 mb-1 wrapper-content" fxLayout="column">
    <div fxLayout="column" fxLayoutGap="10px" class="mb-1 available-agent-list" [hidden]="!displayContent"
      *ngIf="has_available_agent">
      <ng-container *ngFor="let agent of availableAgentsOrdered; let i = index">
        <div fxLayout="column" class="bg-gray agent-wrapper">
          <div fxFlex>
            <agent-item [avatar]="true" [agent]="agent" [actions]="agentActions" actionDisplayType="toolbar"
              [displayCallInfo]="true">
            </agent-item>
          </div>
          <div fxFlex *ngIf="displayGroup" class="group-list-wrapper">
            <agent-groups [agent]="agent"></agent-groups>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-card>
</ng-container>
